/**
 * A regra de entrada: um vínculo entra direto; N escolhe, e o app lembra.
 *
 * Função pura, testável sem React nem rede.
 */
import { contextKey, type AvailableContext } from './types';

export type EntryDecision =
  | { kind: 'none' }
  | { kind: 'direct'; context: AvailableContext; reason: 'only-one' | 'remembered' }
  | { kind: 'choose'; contexts: AvailableContext[] };

export function decideEntry(contexts: AvailableContext[], rememberedKey: string | null): EntryDecision {
  if (contexts.length === 0) return { kind: 'none' };
  if (contexts.length === 1) return { kind: 'direct', context: contexts[0], reason: 'only-one' };
  if (rememberedKey) {
    const lembrado = contexts.find((c) => contextKey(c) === rememberedKey);
    if (lembrado) return { kind: 'direct', context: lembrado, reason: 'remembered' };
  }
  return { kind: 'choose', contexts };
}
